import { render } from "./VToasts.vue?vue&type=template&id=340bf510"
import script from "./VToasts.vue?vue&type=script&lang=js"
export * from "./VToasts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__